import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatState, ITimeLineItem, Message } from './types';
import { v4 as uuidv4 } from 'uuid';
import { SENDER_TYPES } from './constants';

export const initialState: ChatState = {
  isLoading: false,
  messages: [],
  currentSessionId: null,
  temporarySessionId: null,
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setCurrentSessionId: (state, action: PayloadAction<string>) => {
      state.currentSessionId = action.payload;
    },
    getMessages: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
    },
    getMessagesSuccess: (state, action: PayloadAction<ITimeLineItem[]>) => {
      const messages: Message[] = [];
      action.payload.forEach((message: ITimeLineItem) => {
        messages.push({
          sender: SENDER_TYPES.USER,
          message: message.userMessage,
          createdAt: message.createdAt,
          sessionId: message.sessionId,
        });
        messages.push({
          sender: SENDER_TYPES.ASSISTANT,
          message: message.aiAnswer,
          createdAt: message.createdAt,
          sessionId: message.sessionId,
        });
      });
      state.messages = messages;
      state.isLoading = false;
    },
    getMessagesFailed: (state) => {
      state.isLoading = false;
    },
    setMessage: (state, action: PayloadAction<Message>) => {
      if (!state.currentSessionId && !state.temporarySessionId) {
        state.temporarySessionId = uuidv4();
      } else if (!state.currentSessionId && action.payload.sessionId) {
        state.currentSessionId = action.payload.sessionId;
      }
      state.messages.push(action.payload);
    },
    onNewChat: (state) => {
      state.currentSessionId = null;
      state.temporarySessionId = null;
      state.messages = [];
    },
    cleanTemporarySession: (state) => {
      state.temporarySessionId = null;
    },
  },
});
export const { actions: chatActions } = chatSlice;
export const useChatSlice = () => {
  return { actions: chatSlice.actions };
};
